import * as React from 'react'

import { useData } from './useData'
import { ScheduleIcon } from '@sales-center/components'
import { ScheduleButton } from '@user/components/Scheduling'
import { ClosingRequirement } from '../../ClosingRequirement'
import type { IScheduleSettingsDetail } from '@user/store/closingRequirements'
import type {
  ENTITY_TYPES,
  IAppointmentInfo,
  CardClosingRequirements,
} from '@sales-center/common'

type Props = {
  entityId: number
  servicesCount: number
  recordClosed: boolean
  entityType: ENTITY_TYPES
  externalLocationId: string
  services: IAppointmentInfo[]
  hasValidLocationAddress: boolean
  scheduleSettings: IScheduleSettingsDetail
  requirementsAndCounts: CardClosingRequirements
  canUpdate: boolean
}

export function SchedulingClosingRequirement(props: Props) {
  const {
    services,
    entityId,
    entityType,
    recordClosed,
    servicesCount,
    externalLocationId,
    requirementsAndCounts,
    hasValidLocationAddress,
    canUpdate,
  } = props

  const {
    disabled,
    countLoading,
    disabledTooltip,
    appointmentCount,
    schedulingComplete,
  } = useData({
    services,
    entityId,
    entityType,
    recordClosed,
    servicesCount,
    externalLocationId,
    requirementsAndCounts,
    hasValidLocationAddress,
    canUpdate,
  })

  return (
    <ClosingRequirement
      title="Scheduling"
      entityId={entityId}
      isDisabled={disabled}
      icon={<ScheduleIcon />}
      linkText="Appointment History"
      requirement="scheduling"
      count={appointmentCount}
      countLoading={countLoading}
      isComplete={schedulingComplete}
      isDisabledText={disabledTooltip}
      button={<ScheduleButton {...props} disabled={disabled} />}
    />
  )
}
